import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { DailogComponent } from './shared/dialog/dailog.component';
import { AuthService } from './core/services/auth.service';
import { DialogManagerService } from './core/services/dialog-manager.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
	standalone: true,
	imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
	public title = 'RMS - ';

	constructor(
		private readonly dialogRef: MatDialog,
		private readonly authService: AuthService,
		private readonly dialogManager: DialogManagerService
	) {
		// Quick fix for aria-hidden focus issues
		this.setupAccessibilityFix();
	}

	ngOnInit() {
		initFlowbite();
		this.authService.hydrateUserState();
	}

	/**
	 * Targeted fix to prevent aria-hidden from hiding focused tooltip triggers
	 */
	private setupAccessibilityFix(): void {
		// Monitor for focus events specifically on tooltip triggers
		document.addEventListener('focusin', (event) => {
			const focusedElement = event.target as Element;

			// Only fix tooltip triggers and similar interactive elements
			if (focusedElement && this.isTooltipTrigger(focusedElement)) {
				this.ensureTooltipTriggerAccessible(focusedElement);
			}
		});

		// Monitor for focus out to restore aria-hidden if needed
		document.addEventListener('focusout', (event) => {
			const focusedElement = event.target as Element;
			if (focusedElement?.classList?.contains('temp-accessible')) {
				// Delay to ensure focus has moved to a related element
				setTimeout(() => {
					if (
						!document.activeElement ||
						!focusedElement.contains(document.activeElement)
					) {
						this.restoreAriaHiddenToElement(focusedElement);
					}
				}, 50);
			}
		});
	}

	/**
	 * Check if element is a tooltip trigger or similar interactive element
	 */
	private isTooltipTrigger(element: Element): boolean {
		return (
			element.classList.contains('mat-mdc-tooltip-trigger') ||
			element.hasAttribute('matTooltip') ||
			element.classList.contains('cdk-focused') ||
			element.hasAttribute('aria-describedby')
		);
	}

	/**
	 * Ensure tooltip trigger is accessible by removing aria-hidden from its path
	 */
	private ensureTooltipTriggerAccessible(element: Element): void {
		let current: Element | null = element;
		while (current && current !== document.body) {
			if (current.getAttribute('aria-hidden') === 'true') {
				current.removeAttribute('aria-hidden');
				current.classList.add('temp-accessible');
				// Only go up one level to avoid breaking too much
				break;
			}
			current = current.parentElement;
		}
	}

	/**
	 * Restore aria-hidden to a specific element
	 */
	private restoreAriaHiddenToElement(element: Element): void {
		if (element.classList.contains('temp-accessible')) {
			element.setAttribute('aria-hidden', 'true');
			element.classList.remove('temp-accessible');
		}
	}

	getChild(activatedRoute: ActivatedRoute): any {
		if (activatedRoute.firstChild) {
			return this.getChild(activatedRoute.firstChild);
		} else {
			return activatedRoute;
		}
	}

	openDailog() {
		this.dialogRef.open(DailogComponent, {
			data: {
				DailogHeading: 'Pop Up'
			}
		});
	}
}
